import { createApp, ref, onMounted, nextTick } from 'vue';
import $ from 'jquery';
import common from '@page/common/js/common';
// import { Carousel, Slide } from 'vue3-carousel';
import Swiper from 'swiper';

import useSetEnv from '@global/composable/useSetEnv';
import useDialog from '@composable/useDialog';
import useAxiosAPI from '@global/composable/api/useAxiosAPI';
import useModalStore from '@global/stores/useModalStore';

import Pagination from '@global/components/common/pagination/PaginationLayout.vue';

import WishBtn from '@components/WishBtn.vue';
import BrandBtn from '@components/BrandBtn.vue';
import ShareBtn from '@components/ShareBtn.vue';
import CartDialog from '@components/CartDialog.vue';
import FoodDialog from '@components/FoodDialog.vue';

import SortApp from '@page/shop/components/SortApp.vue';
import articleBlock from '@page/brandInfo/components/Article.vue';

const { setEnv } = useSetEnv();
const { openDialog, openFoodDialog } = useDialog();
const { getSortConditionAPI } = useAxiosAPI();

require('@global/vendors/jquery.sticky-kit');

const app = createApp({
  components: {
    Pagination,
    WishBtn,
    BrandBtn,
    ShareBtn,
    SortApp,
    CartDialog,
    FoodDialog,
    articleBlock,
  },
  setup() {
    const largeMode = ref(false);
    const sortConditionDatas = ref({});
    const sortConditionIsLoad = ref(false);
    const modalStore = useModalStore();
    const { openModal } = modalStore;

    getSortCondition();

    function getSortCondition() {
      getSortConditionAPI()
        .then((res) => {
          if (res.data.Code === 200) {
            sortConditionDatas.value = res.data.Response;
            sortConditionIsLoad.value = true;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }

    onMounted(() => {
      nextTick(() => {
        // eslint-disable-next-line no-new
        new Swiper('.banner-swiper', {
          slidesPerView: 1,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
        });
      });
    });

    return {
      largeMode,
      sortConditionDatas,
      sortConditionIsLoad,
      getSortCondition,
      openDialog,
      openFoodDialog,
      openModal,
    };
  },
});

app.mount('#app-shop');

$('.product-menu-pc').stick_in_parent({ offset_top: 180 });

// 刪除後端加上的手機版過濾
if (window.innerWidth >= 768) {
  $('#sort-app-mb').remove();
}

if (setEnv.myEquipment()) {
  // const logoText = $('.brand-logo-m');
  // $('.header-inner').prepend(logoText);
  // $('#bottom-more').click((e) => {
  //   $('.logo-u').css('display', 'block');
  //   $('.brand-logo-m').css('display', 'none');
  // });
  // $('#header-close').click((e) => {
  //   $('.logo-u').css('display', 'none');
  //   $('.brand-logo-m').css('display', 'block');
  // });
}
